import React, { useRef, useEffect, useMemo } from 'react';
import DataGrid, { Column, Editing, Lookup } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import IPromotionCondition from "../../models/IPromotionCondition";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';

export default function GestionPromotionCondition() {
  const promotionFormDataSource = useCustomDataSource<IPromotionCondition, IPromotionCondition>({ path: "promotionCondition", primaryKey: "idPromotionCondition" });
  const { selectedDataRow: selectedPromotion, setMainForm, mode, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = promotionFormDataSource;
  const formRef = useRef<FormRef>(null);
  const { editorOptions: categoriesClientEditorOption, PopupGestion: PopupGestionCategoriesClient } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'categorieclient', setDataRow: () => setDataRow("idCategorieClient"), showClear: mode !== Mode.Lecture, titre: "Gestion des catégories de clients" });

  const typeEditorOptions = useMemo(() => {
    return { dataSource: [categoriesClientEditorOption] };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  return (
    <FormListBase data={promotionFormDataSource}>
      <FormListBaseGrid dataSource={promotionFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
        }}
      >
        <Column key={"grid-col-typeAuxiliaire"} dataField={"typeAuxiliaire"} caption="Type" allowHiding={false} />
        <Column key={"grid-col-quantite"} dataField={"quantite"} caption="Quantite" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedPromotion?.typeAuxiliaire || ''} `} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ disabled: !isFieldModifier }} />
      <FormListBaseTab>
        <TabItem title="Informations">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPromotion || {} as IPromotionCondition} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>

          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedPromotion || {} as IPromotionCondition} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}

function setDataRow(arg0: string) {
  throw new Error('Function not implemented.');
}